module.exports = __webpack_public_path__ + "static/img/dn_img.3ca5bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn_img.png
// module id = eB8N
// module chunks = 3